/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Typography from '@material-ui/core/Typography';

const ErrorInput = ({ errorMessage, classes = '' }) => {
    return (
        <Typography variant="body2" color="error" className={classes}>
            {errorMessage}
        </Typography>
    );
};

export default ErrorInput;
